/**
 * Espelho do catálogo de permissões do back-end
 * (com.br.oam.api.security.PermissoesSistema).
 *
 * Convenção: `<acao>_<tela>` — por exemplo `visualizar_lista_pessoas`,
 * `cadastrar_lista_pessoas`, `editar_lista_pessoas`, `excluir_lista_pessoas`.
 * Cada ação relevante de cada tela tem a sua permissão, para que um grupo possa
 * liberar a consulta sem liberar a alteração.
 *
 * Qualquer código novo precisa ser acrescentado nos dois lados: aqui e no
 * catálogo Java. O back-end é a autoridade — este arquivo serve para esconder
 * botões e barrar rotas antes da chamada, nunca como única barreira.
 */
export const PERMISSOES = {
  // Início
  ACESSAR_HOME: "acessar_home",

  // Calendário
  VISUALIZAR_CALENDARIO: "visualizar_calendario",
  CADASTRAR_CALENDARIO: "cadastrar_calendario",
  EDITAR_CALENDARIO: "editar_calendario",
  EXCLUIR_CALENDARIO: "excluir_calendario",

  // Lista de pessoas
  VISUALIZAR_LISTA_PESSOAS: "visualizar_lista_pessoas",
  CADASTRAR_LISTA_PESSOAS: "cadastrar_lista_pessoas",
  EDITAR_LISTA_PESSOAS: "editar_lista_pessoas",
  EXCLUIR_LISTA_PESSOAS: "excluir_lista_pessoas",
  UNIFICAR_LISTA_PESSOAS: "unificar_lista_pessoas",

  // Usuários de acesso
  VISUALIZAR_ACESSO_USUARIOS: "visualizar_acesso_usuarios",
  EDITAR_ACESSO_USUARIOS: "editar_acesso_usuarios",
  RESETAR_2FA_ACESSO_USUARIOS: "resetar_2fa_acesso_usuarios",

  // Grupos de acesso
  VISUALIZAR_GRUPOS_ACESSO: "visualizar_grupos_acesso",
  CADASTRAR_GRUPOS_ACESSO: "cadastrar_grupos_acesso",
  EDITAR_GRUPOS_ACESSO: "editar_grupos_acesso",
  EXCLUIR_GRUPOS_ACESSO: "excluir_grupos_acesso",
  DUPLICAR_GRUPOS_ACESSO: "duplicar_grupos_acesso",
  GERENCIAR_MEMBROS_GRUPOS_ACESSO: "gerenciar_membros_grupos_acesso",

  // Gestão de menus
  VISUALIZAR_MENUS: "visualizar_menus",
  CADASTRAR_MENUS: "cadastrar_menus",
  EDITAR_MENUS: "editar_menus",
  EXCLUIR_MENUS: "excluir_menus",

  // Medicamentos
  VISUALIZAR_MEDICAMENTOS: "visualizar_medicamentos",
  CADASTRAR_MEDICAMENTOS: "cadastrar_medicamentos",
  EDITAR_MEDICAMENTOS: "editar_medicamentos",
  EXCLUIR_MEDICAMENTOS: "excluir_medicamentos",
  SUGERIR_IA_MEDICAMENTOS: "sugerir_ia_medicamentos",
  OCR_MEDICAMENTOS: "ocr_medicamentos",
  DITAR_ATENDIMENTO: "ditar_atendimento",

  // Acervo digitalizado
  VISUALIZAR_ACERVO: "visualizar_acervo",
  DIGITALIZAR_ACERVO: "digitalizar_acervo",
  CONFERIR_ACERVO: "conferir_acervo",
  VISUALIZAR_AUDITORIA_IA: "visualizar_auditoria_ia",

  // Catálogo de medicamentos
  VISUALIZAR_CATALOGO_MEDICAMENTOS: "visualizar_catalogo_medicamentos",
  CADASTRAR_CATALOGO_MEDICAMENTOS: "cadastrar_catalogo_medicamentos",
  EDITAR_CATALOGO_MEDICAMENTOS: "editar_catalogo_medicamentos",
  EXCLUIR_CATALOGO_MEDICAMENTOS: "excluir_catalogo_medicamentos",

  // Pagamentos avulsos
  VISUALIZAR_PAGAMENTOS: "visualizar_pagamentos",
  CADASTRAR_PAGAMENTOS: "cadastrar_pagamentos",

  // Financeiro — lançamentos
  VISUALIZAR_FINANCEIRO: "visualizar_financeiro",
  CADASTRAR_FINANCEIRO: "cadastrar_financeiro",
  EDITAR_FINANCEIRO: "editar_financeiro",
  EXCLUIR_FINANCEIRO: "excluir_financeiro",
  EFETIVAR_FINANCEIRO: "efetivar_financeiro",
  REABRIR_FINANCEIRO: "reabrir_financeiro",
  CANCELAR_FINANCEIRO: "cancelar_financeiro",
  GERAR_MES_FINANCEIRO: "gerar_mes_financeiro",
  VISUALIZAR_RESUMO_FINANCEIRO: "visualizar_resumo_financeiro",

  // Financeiro — categorias
  VISUALIZAR_CATEGORIAS_FINANCEIRAS: "visualizar_categorias_financeiras",
  CADASTRAR_CATEGORIAS_FINANCEIRAS: "cadastrar_categorias_financeiras",
  EDITAR_CATEGORIAS_FINANCEIRAS: "editar_categorias_financeiras",
  EXCLUIR_CATEGORIAS_FINANCEIRAS: "excluir_categorias_financeiras",

  // Financeiro — contas recorrentes
  VISUALIZAR_CONTAS_RECORRENTES: "visualizar_contas_recorrentes",
  CADASTRAR_CONTAS_RECORRENTES: "cadastrar_contas_recorrentes",
  EDITAR_CONTAS_RECORRENTES: "editar_contas_recorrentes",
  EXCLUIR_CONTAS_RECORRENTES: "excluir_contas_recorrentes",

  // Eventos
  VISUALIZAR_EVENTOS: "visualizar_eventos",
  CADASTRAR_EVENTOS: "cadastrar_eventos",
  EDITAR_EVENTOS: "editar_eventos",
  EXCLUIR_EVENTOS: "excluir_eventos",
  PUBLICAR_EVENTOS: "publicar_eventos",
  ATIVAR_EVENTOS: "ativar_eventos",
  GERENCIAR_MODALIDADES_EVENTOS: "gerenciar_modalidades_eventos",
  ENCERRAR_MODALIDADES_EVENTOS: "encerrar_modalidades_eventos",
  GERENCIAR_CAMPOS_EVENTOS: "gerenciar_campos_eventos",

  // Inscritos no retiro
  VISUALIZAR_INSCRITOS_RETIRO: "visualizar_inscritos_retiro",
  CADASTRAR_INSCRITOS_RETIRO: "cadastrar_inscritos_retiro",
  EDITAR_INSCRITOS_RETIRO: "editar_inscritos_retiro",
  EXCLUIR_INSCRITOS_RETIRO: "excluir_inscritos_retiro",
  APROVAR_INSCRITOS_RETIRO: "aprovar_inscritos_retiro",
  VER_STATUS_INSCRITOS_RETIRO: "ver_status_inscritos_retiro",
  ENVIAR_WHATSAPP_INSCRITOS_RETIRO: "enviar_whatsapp_inscritos_retiro",
  STANDBY_INSCRITOS_RETIRO: "standby_inscritos_retiro",
  SELECIONAR_PALESTRANTES_RETIRO: "selecionar_palestrantes_retiro",
  VISUALIZAR_QUARTOS_RETIRO: "visualizar_quartos_retiro",
  ENCERRAR_INSCRICOES_RETIRO: "encerrar_inscricoes_retiro",
  ABRIR_INSCRICOES_RETIRO: "abrir_inscricoes_retiro",
  ENCERRAR_INSCRICOES_EQUIPE_RETIRO: "encerrar_inscricoes_equipe_retiro",
  ABRIR_INSCRICOES_EQUIPE_RETIRO: "abrir_inscricoes_equipe_retiro",
  VISUALIZAR_PAGAMENTOS_INSCRITOS_RETIRO: "visualizar_pagamentos_inscritos_retiro",
  CADASTRAR_PAGAMENTOS_INSCRITOS_RETIRO: "cadastrar_pagamentos_inscritos_retiro",
  EXCLUIR_PAGAMENTOS_INSCRITOS_RETIRO: "excluir_pagamentos_inscritos_retiro",

  // Inscrição pelo próprio interessado
  CADASTRAR_INSCRICAO_RETIRO: "cadastrar_inscricao_retiro",
  CADASTRAR_INSCRICAO_RETIRO_EQUIPE: "cadastrar_inscricao_retiro_equipe",

  // Depoimentos
  VISUALIZAR_DEPOIMENTOS: "visualizar_depoimentos",
  CADASTRAR_DEPOIMENTOS: "cadastrar_depoimentos",
  EXCLUIR_DEPOIMENTOS: "excluir_depoimentos",

  // Gestão de quartos
  VISUALIZAR_GESTAO_QUARTOS: "visualizar_gestao_quartos",
  EDITAR_GESTAO_QUARTOS: "editar_gestao_quartos",

  // Fila de atendimento
  VISUALIZAR_FILA: "visualizar_fila",
  CADASTRAR_FILA: "cadastrar_fila",
  CHAMAR_FILA: "chamar_fila",
  VISUALIZAR_PAINEL_FILA: "visualizar_painel_fila",
  RECHAMAR_PAINEL_FILA: "rechamar_painel_fila",

  // Programação
  VISUALIZAR_PROGRAMACAO: "visualizar_programacao",
  CADASTRAR_PROGRAMACAO: "cadastrar_programacao",
  EDITAR_PROGRAMACAO: "editar_programacao",
  EXCLUIR_PROGRAMACAO: "excluir_programacao",

  // Transmissão ao vivo
  ACESSAR_AO_VIVO: "acessar_ao_vivo",
  ACESSAR_AO_VIVO_SEM_GEOLOCALIZACAO: "acessar_ao_vivo_sem_geolocalizacao",

  // Auditoria
  VISUALIZAR_AUDITORIA: "visualizar_auditoria",

  // Configurações
  VISUALIZAR_CONFIGURACOES: "visualizar_configuracoes",
  EDITAR_CONFIGURACOES: "editar_configuracoes",
};

export const temPermissao = (permissoes, permissao) => {
  if (!permissao) return true;
  if (!Array.isArray(permissoes)) return false;
  return permissoes.includes(permissao);
};
